import { render } from "./ContentLightbox.vue?vue&type=template&id=80e29b1c&scoped=true"
import script from "./ContentLightbox.vue?vue&type=script&lang=js"
export * from "./ContentLightbox.vue?vue&type=script&lang=js"

import "./ContentLightbox.vue?vue&type=style&index=0&id=80e29b1c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80e29b1c"]])

export default __exports__